import clsx from "clsx"
import Link from "next/link"
import React from "react"

import LinkOutIcon from "../../../../public/swell/external-link.svg"
import Button from "../Button"
import PageGrid from "../PageGrid"

interface HeroProps {
  headline: string
  subHeadline: string
  buttonCTA?: string
  buttonLink?: string
  secondaryLink?: string
  secondaryLinkText?: string
  children?: React.ReactNode
}

const HeroSection: React.FC<HeroProps> = ({
  headline,
  subHeadline,
  buttonCTA,
  buttonLink,
  secondaryLink = "",
  secondaryLinkText = "",
  children,
}) => (
  <section className="py-12 bg-white-100 text-gray-90 md:py-20 lg:py-24">
    <PageGrid className="p-4">
      <div className="col-span-full">
        <h1 className="heading2 md:heading1 lg:headline5">{headline}</h1>
        <h2
          className={clsx(
            "mt-4 headline2 md:headline1 lg:hero blue-gradient-bds",
          )}
        >
          {subHeadline}
        </h2>
        {buttonLink && (
          <div className="flex items-center flex-row flex-wrap md:flex gap-4 mt-10 md:mt-14 lg:mt-20">
            <Button to={buttonLink} className="inline-flex">
              {buttonCTA}
            </Button>
            {secondaryLink && (
              <Link
                href={secondaryLink}
                target="_blank"
                className="flex content-center align-center relative"
              >
                {secondaryLinkText}
                <LinkOutIcon className="ml-1" stroke="#6DC3FF" />
              </Link>
            )}
          </div>
        )}
      </div>
    </PageGrid>
    {children}
  </section>
)
export default HeroSection
